import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Landing } from './pages/Landing';
export function App() {
  return <>
      <MetaPixel data-id="element-0" data-mp="35bsiz8iy1qyi" />
      <Landing data-id="element-1" data-mp="35eepr5y0g2fo" />
    </>;
}